export class RemoveBounceMedDialogModel {
    constructor(
        public item: any
    ) {}
  }